import { Component } from '@angular/core';
import { TagsLogicService, TagMappedItem, ITagMappedItem } from '@app/logic/tags';
import { PermissionsPermissions } from '../../../../core/permissions';
import { TagsDialogComponent } from './components/tags-dialog/tags-dialog.component';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { MatDialogRef } from '@angular/material/dialog';
import { isNullOrWhiteSpace } from 'cb-hub-lib';
import { ITagDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

@Component({
    selector: 'cb-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    standalone: false
})
export class TagsComponent extends BaseSimpleListViewDirective<ITagDto, TagsLogicService> {

    public searchResults: ITagDto[] = [];
    public searchResultsLoaded = false;

    public readonly displayedColumns: string[] = ['name', 'key', 'active', 'actions'];

    constructor(
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly dialog: CbDialogService,
        private readonly tagsLogicService: TagsLogicService,
    ) {
        super(
            dialog,
            tagsLogicService,
            TagsDialogComponent,
            'Tag',
            TagMappedItem,
            permissionsPermissions
        );
    }

    public openDialog(mappedItem: ITagMappedItem, dialogHeading: string): MatDialogRef<any> {
        return this.cbDialog
            .open(
                this.dialogComponent,
                {
                    minWidth: '40%',
                    data: {
                        dialogHeading,
                        mappedItem,
                        existingTags: this.searchResults.map(x => x.key).filter(x => !isNullOrWhiteSpace(x) && mappedItem.key !== x)
                    },
                }
            );
    }

    public generateReport(): void {
        this.tagsLogicService.generateReport().pipe(take(1)).subscribe();
    }
}
